export default __webpack_public_path__ + "static/media/twitter_pink.394f0479.svg";